import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const CollapseIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M21 19L21 5C21 3.897 20.103 3 19 3L5 3C3.897 3 3 3.897 3 5L3 19C3 20.103 3.897 21 5 21L19 21C20.103 21 21 20.103 21 19ZM9.293 11.293L13.293 7.293C13.683 6.903 14.317 6.903 14.707 7.293C15.097 7.683 15.097 8.317 14.707 8.707L11.414 12L14.707 15.293C15.097 15.683 15.097 16.317 14.707 16.707C14.317 17.097 13.683 17.097 13.293 16.707L9.293 12.707C8.902 12.317 8.902 11.683 9.293 11.293Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

CollapseIcon.propTypes = {
  sx: PropTypes.object,
};

export default CollapseIcon;
